import styled from 'styled-components';

import Button from 'components/shared/Button';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

// The action for the payer-disambiguation state, in the slideout's pinned footer alongside every
// other primary action. It was a sticky bar at the end of the candidate list, which cannot sit at
// the bottom of a scrolling body that has padding — sticky positions against the padding box, so
// cards kept scrolling past in the strip below it.
interface Props {
  selectedId: string | null;
  onRun: () => void;
  isRunning: boolean;
}

export default function SelectPayerFooter({ selectedId, onRun, isRunning }: Props) {
  return (
    <>
      {/* Absent rather than empty once a payer is picked. The slideout stacks this footer on a
          phone, where an empty element is still a row: it left the footer's gap above the only
          control with nothing in it. */}
      {!selectedId && <Hint>A payer must first be selected to run an eligibility check</Hint>}
      <RunButton
        disabled={!selectedId || isRunning}
        loading={isRunning}
        onClick={onRun}
        data-testid='run-eligibility-check'>
        Run Eligibility Check
      </RunButton>
    </>
  );
}

const Hint = styled(BodySmall)`
  color: ${colors.black50};
`;

// Right-aligned on a desktop whether or not the hint is beside it — the footer's space-between
// does that only while there are two children. A no-op on a phone, where the footer stacks and
// gives this the full width.
const RunButton = styled(Button)`
  margin-left: auto;
`;
